import React, { useState, useEffect } from 'react';

import { Breadcrumb, Button, Col, Dropdown, Form, Input, InputNumber, Menu, message, Modal, Row, Space, Spin, Table, Typography } from 'antd';
import { default_tag, ELM_STANDARD, MENU_ITEMS, ROLE_RENDER } from '../../util/options';
import AgentService from '../../services/user/agent.service';
import { useUserContext } from '../../contexts/UserContext';
import { DATE_FORMAT, DB, MSG, NUMBER_FORMAT, openNotification } from '../../util/constant';
import { CloseOutlined, DownOutlined, EditOutlined, KeyOutlined, LockOutlined, MinusOutlined, PlusOutlined, SaveOutlined, UserOutlined } from '@ant-design/icons';


const ListUser = (props) => {
    const { custom } = props;
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([])
    const [filterTable, setFilterTable] = useState([])
    const [breadcrumbs, setBreadcrumbs] = useState([])
    const { user, userAction } = useUserContext();
    const [searchValue, setSearchValue] = useState('')


    const [modalData, setModalData] = useState(null)
    const [modalVisible, setModalVisible] = useState({ edit: false, changePassword: false, deposit: false, withdraw: false });
    const [isModalLoading, setIsModalLoading] = useState(false);

    const [editForm] = Form.useForm();
    const [changePasswordForm] = Form.useForm();
    const [depositForm] = Form.useForm();
    const [withdrawForm] = Form.useForm();

    const forms = { edit: editForm, changePassword: changePasswordForm, deposit: depositForm, withdraw: withdrawForm };
    const UserActionsService = {
        edit: AgentService.updateUser,
        changePassword: AgentService.changeUserPassword,
        deposit: AgentService.depositToUser,
        withdraw: AgentService.withdrawFromUser,
        listUser: custom === 'locked' ? AgentService.listLockedUser : AgentService.listUser
    }

    const submit = async (param) => {
        try {
            await forms[param].validateFields()

            setIsModalLoading(true)
            const send = await UserActionsService[param]({ ...forms[param].getFieldsValue(), userId: modalData.id })
            setIsModalLoading(false)
            if (send === `OK`) {
                forms[param].resetFields()
                setModalVisible({ ...modalVisible, [param]: false })
                message.success(MSG.COMMON.UPDATE.SUCCEED)
                setLoading(true)
                prepareData();
                if (param === 'deposit' || 'withdraw') {
                    userAction.updateBalance()
                }
            } else if (send === `NOT_ENOUGH_BALANCE`) {
                userAction.updateBalance()
                message.error(MSG.COMMON.VALIDATE.NOT_ENOUGH_BALANCE)
            } else {
                message.error(MSG.COMMON.VALIDATE.FAILED)
            }


            setLoading(false);
        } catch (err) {
            message.error(MSG.COMMON.VALIDATE.FAILED)
            setLoading(false);
        }
    }


    const closeModal = (param) => {
        setModalVisible({ ...modalVisible, [param]: false });
        setModalData(null);
        forms[param].resetFields()
    }

    const changeUser = async (param) => {
        if (param.id === breadcrumbs[breadcrumbs.length - 1].id) {
            openNotification('info', `ระบบได้แสดงผลสมาชิก ${param.username} อยู่แล้ว`, '', 'bottomLeft')
            return
        }

        try {
            setLoading(true)
            const data = await UserActionsService.listUser(param.id)
            setList(data)
            setFilterTable(data)
            let index = breadcrumbs.findIndex(b => b.id === param.id)

            if (index === -1) {
                const bc = [...breadcrumbs]
                bc.push(param)
                setBreadcrumbs([...bc])
            } else {
                let newArr = JSON.parse(JSON.stringify(breadcrumbs));
                newArr.splice(index + 1)
                setBreadcrumbs(newArr)
            }
            setLoading(false)
        } catch (err) {
            setLoading(false)
        }
    }

    const updateUserStatus = async (id) => {
        try {
            setLoading(true)
            const send = await AgentService.updateUserStatus({ userId: id })
            setIsModalLoading(false)
            if (send === `OK`) {
                message.success(MSG.COMMON.UPDATE.SUCCEED)
                prepareData();
            } else if (send === `UPLINELOCKED`) {
                message.success(MSG.COMMON.VALIDATE.UPLINE_LOCKED)
            } else {
                message.error(MSG.COMMON.VALIDATE.FAILED)
            }
            setLoading(false);
        } catch (err) {
            message.error(MSG.COMMON.VALIDATE.FAILED)
            setLoading(false);
        }
    }



    useEffect(() => {
        prepareData();
    }, [])

    useEffect(() => {
        forms.edit.setFieldsValue(modalData)
    }, [forms.edit, modalData])

    const prepareData = async () => {
        const data = await UserActionsService.listUser()
        setList(data)
        setFilterTable(data)
        setBreadcrumbs([{ id: user.id, username: user.username }])
        setLoading(false)
    }


    const modalProps = (param) => {
        return {
            visible: modalVisible[param],
            footer: [
                <Button key="back" onClick={() => closeModal(param)} icon={<CloseOutlined />}>ยกเลิก</Button>,
                <Button type="primary" key="submit" onClick={() => submit(param)} icon={<SaveOutlined />}>ยืนยัน</Button>
            ],
            onOk: () => submit(param),
            onCancel: () => closeModal(param),
            forceRender: true,
        }
    }

    const formProps = (param) => {
        return {
            form: forms[param],
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
            autoComplete: "new-password",
            initialValues: modalData
        }
    }

    const menu = (record) => {
        return <Menu
            items={[
                {
                    label: 'แก้ไขข้อมูล',
                    key: 'edit',
                    icon: <EditOutlined />,
                    onClick: () => { setModalVisible({ ...modalVisible, edit: true }); setModalData(record) }
                },
                {
                    label: 'เปลี่ยนรหัสผ่าน',
                    key: 'changePassword',
                    icon: <KeyOutlined />,
                    onClick: () => { setModalVisible({ ...modalVisible, changePassword: true }); setModalData(record) }
                },
                {
                    label: 'ฝาก',
                    key: 'deposit',
                    icon: <PlusOutlined />,
                    onClick: () => { setModalVisible({ ...modalVisible, deposit: true }); setModalData(record) }
                },
                {
                    label: 'ถอน',
                    key: 'withdraw',
                    icon: <MinusOutlined />,
                    onClick: () => { setModalVisible({ ...modalVisible, withdraw: true }); setModalData(record) }
                },
                {
                    type: 'divider',
                },
                {
                    label: record.status !== DB.USER.STATUS.LOCKED ? 'ล็อคบัญชี' : 'ปลดล็อคบัญชี',
                    key: 'lock',
                    icon: <LockOutlined />,
                    disabled: record.status === DB.USER.STATUS.UPLINELOCKED,
                    onClick: () => { updateUserStatus(record.id) }
                },
            ]}
        />
    }
    return (
        <div className='agent-page-group list-user-page'>
            <Spin {...ELM_STANDARD.spin} spinning={loading}>
                <div className='page-title'>
                    <Typography className='title'>{MENU_ITEMS.userList.label}</Typography>
                </div>

                <div className='page-content-wrapper'>
                    <div className='page-content'>
                        <div className='breadcrumb-styled'>
                            <Breadcrumb separator=">" className='unselectable'>
                                {breadcrumbs.map((item) =>
                                    <Breadcrumb.Item key={item.id}
                                        onClick={() => changeUser({ id: item.id, username: item.username })}>{item.username}</Breadcrumb.Item>
                                )}
                            </Breadcrumb>
                        </div>

                        <div className="header-wrapper">
                            <Row gutter={[{ xs: 16, sm: 16, md: 48, lg: 64 }, 16]} align="middle" justify='space-between' >
                                <Col span={24} className="text-right">
                                    <Space size={"large"}>
                                        <div className='search'>
                                            <Input.Search
                                                allowClear
                                                value={searchValue}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const filterTable = [...list].filter(o =>
                                                        Object.keys(o).some(k =>
                                                            (k === 'username' || 'name' || 'phone') &&
                                                            String(o[k])
                                                                .toLowerCase()
                                                                .includes(String(value).toLowerCase())
                                                        )
                                                    );
                                                    setFilterTable(filterTable)
                                                    setSearchValue(value)
                                                }}
                                                placeholder="ค้นหา" />
                                        </div>
                                    </Space>
                                </Col>
                            </Row>
                        </div>

                        <Table
                            scroll={{ x: 'max-content' }}
                            rowKey={(record) => record.id}
                            pagination={ELM_STANDARD.pagination}
                            dataSource={filterTable}
                            rowClassName={(record) => [DB.USER.STATUS.LOCKED, DB.USER.STATUS.UPLINELOCKED].includes(record.status) ? 'row-locked-user' : ''}
                            columns={[
                                {
                                    title: 'ลำดับ',
                                    dataIndex: 'i',
                                    key: 'i',
                                    align: 'center',
                                    render: (text, record, index) => {
                                        return index + 1
                                    },
                                },
                                {
                                    title: 'ชื่อผู้ใช้',
                                    dataIndex: 'username',
                                    key: 'username',
                                    render (value, record) {
                                        return record.role === DB.USER.ROLE.MEMBER ? value : <Typography.Link onClick={() => changeUser({ id: record.id, username: record.username })}>{value}</Typography.Link>
                                    },
                                    sorter: ((a, b) => a.username.localeCompare(b.username))
                                },
                                {
                                    title: 'ระดับ',
                                    dataIndex: 'role',
                                    key: 'role',
                                    align: 'center',
                                    render (value) {
                                        return ROLE_RENDER[value]
                                    },
                                    sorter: ((a, b) => a.role.localeCompare(b.role))
                                },
                                {
                                    title: 'ชื่อ',
                                    dataIndex: 'name',
                                    key: 'name',
                                    align: 'center',
                                    sorter: ((a, b) => a.name.localeCompare(b.name))
                                },
                                {
                                    title: 'โทรศัพท์',
                                    dataIndex: 'phone',
                                    key: 'phone',
                                    align: 'center',
                                },
                                {
                                    title: 'สมัครเมื่อ',
                                    dataIndex: 'createdAt',
                                    key: 'createdAt',
                                    align: 'center',
                                    render (value) {
                                        return DATE_FORMAT.thaiHalf(value)
                                    }
                                },
                                {
                                    title: 'เข้าใช้งานล่าสุด',
                                    dataIndex: 'latestLogin',
                                    key: 'latestLogin',
                                    align: 'center',
                                    render (value) {
                                        return value ? DATE_FORMAT.thaiHalf(value) : '-'
                                    },
                                    sorter: ((a, b) => new Date(b.latestLogin) - new Date(a.latestLogin))
                                },
                                {
                                    title: 'สถานะ',
                                    dataIndex: 'status',
                                    key: 'status',
                                    align: 'center',
                                    render (value) {
                                        return default_tag[value]
                                    },
                                    sorter: ((a, b) => a.status.localeCompare(b.status))
                                },
                                {
                                    title: 'กระเป๋า',
                                    dataIndex: 'amount',
                                    key: 'amount',
                                    align: 'right',
                                    render (value) {
                                        return value ? <Typography.Text type="success">{NUMBER_FORMAT.default(value)}</Typography.Text> : "-"
                                    },
                                    sorter: ((a, b) => a.amount - b.amount)
                                },
                                {
                                    title: 'Actions',
                                    dataIndex: 'name',
                                    key: 'name',
                                    align: 'center',
                                    render (value, record) {
                                        return <Dropdown overlay={() => menu(record)} trigger={['click']} disabled={breadcrumbs.length > 1}>
                                            <Button>
                                                <Space>
                                                    จัดการสมาชิก
                                                    <DownOutlined />
                                                </Space>
                                            </Button>
                                        </Dropdown>
                                    }
                                },
                            ]}
                        />
                    </div>
                </div >

                <Modal title={<span><UserOutlined /> แก้ไขข้อมูลสมาชิก</span>}
                    {...modalProps('edit')}>
                    <Spin  {...ELM_STANDARD.spin} spinning={isModalLoading}>
                        <Form
                            {...formProps('edit')}>
                            <Form.Item
                                name="name"
                                label="ชื่อ"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณาระบุชื่อ!',
                                        whitespace: true,
                                    },
                                    {
                                        max: 100,
                                        message: 'ความยาวไม่เกิน 100 ตัวอักษร!',
                                    },
                                ]}
                            >
                                <Input placeholder="Name" autoComplete="new-password" />
                            </Form.Item>

                            <Form.Item
                                name="phone"
                                label="โทรศัพท์"
                                rules={[
                                    {
                                        pattern: new RegExp(/^[0-9]{10,12}$/), message: 'กรุณาระบุเบอร์โทรให้ถูกต้อง!',
                                        warningOnly: true,
                                    }
                                ]}
                            >
                                <Input placeholder="Phone" autoComplete="new-password" />
                            </Form.Item>

                        </Form>
                    </Spin>
                </Modal>


                <Modal title={<span><KeyOutlined /> เปลี่ยนรหัสผ่าน</span>}
                    {...modalProps('changePassword')}>
                    <Spin  {...ELM_STANDARD.spin} spinning={isModalLoading}>
                        <Form
                            {...formProps('changePassword')}>
                            <Form.Item
                                name="password"
                                label=" รหัสผ่านใหม่"
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณาระบุรหัสผ่าน!',
                                    },
                                    {
                                        min: 6,
                                        message: 'ความยาว 6 ตัวอักษรขึ้นไป!',
                                    },
                                    {
                                        max: 255,
                                        message: 'ความยาวไม่เกิน 255 ตัวอักษร!',
                                    },
                                ]}
                            >
                                <Input.Password placeholder="Password" />
                            </Form.Item>
                            <Form.Item
                                name="confirmPassword"
                                label="ยืนยันรหัสผ่านใหม่"
                                hasFeedback
                                dependencies={['password']}
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณายืนยันรหัสผ่าน!',

                                    },
                                    {
                                        min: 6,
                                        message: 'ความยาว 6 ตัวอักษรขึ้นไป!',
                                    },
                                    {
                                        max: 255,
                                        message: 'ความยาวไม่เกิน 255 ตัวอักษร!',
                                    },
                                    {
                                        validator: async (rule, value) => {
                                            if (!value || forms.changePassword.getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('รหัสผ่านไม่ตรงกัน!'));
                                        }
                                    }
                                ]}
                            >
                                <Input.Password placeholder="Confirm password" />
                            </Form.Item>

                        </Form>
                    </Spin>
                </Modal>


                <Modal title={<span><PlusOutlined /> ฝาก</span>}
                    {...modalProps('deposit')}>
                    <Spin  {...ELM_STANDARD.spin} spinning={isModalLoading}>
                        <Form
                            {...formProps('deposit')}>
                            <Form.Item
                                label="จำนวน"
                                name="deposit_amount"
                                rules={[
                                    { required: true, message: 'กรุณาระบุ!' }
                                ]}
                            >
                                <InputNumber
                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                    className='w-100'
                                    step={1}
                                    precision={2}
                                    min={0}
                                    placeholder={`ระบุจำนวนเงิน`} />
                            </Form.Item>

                        </Form>
                    </Spin>
                </Modal>

                <Modal title={<span><MinusOutlined /> ถอน</span>}
                    {...modalProps('withdraw')}>
                    <Spin  {...ELM_STANDARD.spin} spinning={isModalLoading}>
                        <Form
                            {...formProps('withdraw')}>
                            <Form.Item
                                label="จำนวน"
                                name="withdraw_amount"
                                rules={[
                                    { required: true, message: 'กรุณาระบุ!' }
                                ]}
                            >
                                <InputNumber
                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                    className='w-100'
                                    step={1}
                                    precision={2}
                                    min={0}
                                    placeholder={`ระบุจำนวนเงิน`} />
                            </Form.Item>

                        </Form>
                    </Spin>
                </Modal>

            </Spin >
        </div >
    );
}

export default ListUser;
